import React, { Component } from 'react';
import { Button, Grid, Icon, Label, Loader, Placeholder, Popup, Table } from 'semantic-ui-react';
import SearchTableData from '../../../util/SearchTableData';
import { HeaderCursor } from '../../../Professor/ProfessorInputGrades/css';
import axios from 'axios';
import { center, customLabel, CountriesColors as colors, legendStyle } from '../../../Statistics/util';
import { PieChart } from './PieChart';
import PaginationFront from '../../../util/PaginationFront';
import ReactExport from "react-data-export";
import ReportExcelFile from '../../StudentsReports/ReportExcelFile';
import { sanitizeExcelDataSet } from '../../../util/sanitizeExcel';

const ExcelFile = ReportExcelFile;
const { ExcelSheet } = ReactExport.ExcelFile;

class CourseExamsStatistic extends Component {
    constructor(props) {
        super(props);

        this.state = {
            results: [],

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],

            excelDataFilter: [],
        };
        this.getResults = this.getResults.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.data !== nextProps.data) {
            this.setState({
                results: [],
                activePage: 1
            });
        }
    }

    getResults(results) {
        this.setState({ results,
            excelDataFilter:  results.map(el => ([
                { value: el.courseBasicName},
                { value: el.professor},
                { value: el.numberOfStudentsOnCourse},
                { value: el.numberOfDistinctStudentGradedActivities},
                { value: el.numberOfExamRegistrations},
                { value: el.numberOfDistinctStudentsWhoAccessedExam},
                { value: el.numberOfStudentsWhoAccessedExam},
                { value: el.numberOfStudentsWhoPassed},
                { value: el.averagePassedStudentsOnCourse},
                { value: el.averagePassedDistinctStudentGradedActivities},
                { value: el.averagePassed},
                { value: el.numberOfFs},
                { value: el.numberOfEs},
                { value: el.numberOfDs},
                { value: el.numberOfCs},
                { value: el.numberOfBs},
                { value: el.numberOfAs},
                { value: el.numberOfIOs},
                { value: el.numberOfNONPs},
                { value: el.numberOfNPs},
                { value: el.numberOfNAs},
                { value: el.numberOfZs},
                { value: el.numberOfNZs},
                { value: el.numberOfNOs},
                { value: el.numberOfUOs},
                { value: el.averageGrade !== null ? el.averageGrade : ''},
            ]))
        });
        this.handlePaginationChange({}, {activePage: 1})
    }
    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.props.data;
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })


    render() {
        const { data, loader } = this.props;

        const multiDataSet = [
            {
                columns: [
                    { title: 'Predmet',  width: { wpx: 300 }},
                    { title: 'Nastavnik/ica',  width: { wpx: 200 } },
                    { title: 'Broj studenata koji pohađaju predmet - n',  width: { wpx: 250 } },
                    { title: 'Broj različitih prijavljenih studenata na svim ispitima - n₁',  width: { wpx: 350 }},
                    { title: 'Ukupan broj prijava na svim ispitima',  width: { wpx: 250 }},
                    { title: 'Broj različitih studenata koji su izašli na ispite - n₂', width: { wpx: 300 } },
                    { title: 'Ukupan broj izlazaka na svim ispitima',  width: { wpx: 250 }},
                    { title: 'Broj studenata koji su položili ispit - k',  width: { wpx: 250 } },
                    { title: 'Prolaznost - k/n (%)',  width: { wpx: 150 } },
                    { title: 'Prolaznost - k/n₁ (%)',  width: { wpx: 150 } },
                    { title: 'Prolaznost - k/n₂ (%)',  width: { wpx: 150 } },
                    { title: '5 (pet)',  width: { wpx: 100 }},
                    { title: '6 (šest)',  width: { wpx: 100 }},
                    { title: '7 (sedam)', width: { wpx: 100 }},
                    { title: '8 (osam)',  width: { wpx: 100 } },
                    { title: '9 (devet)',  width: { wpx: 100 } },
                    { title: '10 (deset)',  width: { wpx: 100 } },
                    { title: 'ispunio obaveze',  width: { wpx: 100 } },
                    { title: 'nije ocijenjen/nije pristupio',  width: { wpx: 270 } },
                    { title: 'nije položio/la',  width: { wpx: 120 } },
                    { title: 'nije pristupio/la',  width: { wpx: 120 }},
                    { title: 'zadovoljio',  width: { wpx: 100 } },
                    { title: 'nije zadovoljio',  width: { wpx: 120 } },
                    { title: 'nije odbranio',  width: { wpx: 120 } },
                    { title: 'uspješno odbranio',  width: { wpx: 120 } },
                    { title: 'Prosječna ocjena',  width: { wpx: 120 } },
                ],
                data: this.state.results.length === 0 ? this.props.excelData : this.state.excelDataFilter,
            }
        ];

        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        return (
            <div>
                {loader ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div> :
                    <div>
                        {data.length === 0 ? 'Nema podataka za navedenu godinu!' : <Table celled selectable compact size="small" >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan={33} >

                                    <Grid column={2} stackable>
                                        <Grid.Column width={14}>
                                            <SearchTableData
                                                profMozilla
                                                data={data}
                                                getResults={this.getResults}
                                                filterItem={['courseBasicName', 'courseBasicComment', 'professor', 'numberOfStudentsOnCourse',
                                                    'numberOfDistinctStudentGradedActivities', 'numberOfExamRegistrations', 'numberOfDistinctStudentsWhoAccessedExam', 'numberOfStudentsWhoAccessedExam',
                                                    'numberOfStudentsWhoPassed', 'averagePassed', 'numberOfFs', 'numberOfEs',
                                                    'numberOfDs', 'numberOfCs', 'numberOfBs', 'numberOfAs', 'numberOfIOs',
                                                    'numberOfNONPs', 'numberOfNPs', 'numberOfNAs', 'numberOfZs', 'numberOfNOs', 'numberOfUOs', 'numberOfNZs',
                                                    'averageGrade']}
                                            />
                                        </Grid.Column>
                                        <Grid.Column width={2} textAlign="center">
                                            <ExcelFile filename="Prolaznost" element={<Popup
                                                trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                    <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                    <Button.Content visible>
                                                        Excel
                                                    </Button.Content>
                                                </Button>}
                                                content="Preuzmi spisak u Excel-u"
                                                hideOnScroll
                                                position="top center"
                                            />}>
                                                <ExcelSheet dataSet={sanitizeExcelDataSet(multiDataSet)} name="Prolaznost" />
                                            </ExcelFile>

                                        </Grid.Column>
                                    </Grid>
                                </Table.HeaderCell>
                            </Table.Row>
                            <Table.Row>
                                {/*<Table.HeaderCell  width={3}>R. br.</Table.HeaderCell>*/}
                                <Table.HeaderCell colSpan={4} verticalAlign="middle">Predmet
                                    <span style={{ color: '#a6a4a1' }}><br/>Napomena</span></Table.HeaderCell>
                                <Table.HeaderCell colSpan={3} verticalAlign="middle">Nastavnik/ica</Table.HeaderCell>
                                <Table.HeaderCell colSpan={3} verticalAlign="middle">Broj studenata koji pohađaju predmet - n</Table.HeaderCell>
                                <Table.HeaderCell colSpan={3} verticalAlign="middle">Broj različitih prijavljenih studenata na svim ispitima - n₁</Table.HeaderCell>
                                <Table.HeaderCell colSpan={3} verticalAlign="middle">Ukupan broj prijava na svim ispitima</Table.HeaderCell>
                                <Table.HeaderCell colSpan={3} verticalAlign="middle">Broj različitih studenata koji su izašli na ispite - n₂</Table.HeaderCell>
                                <Table.HeaderCell colSpan={3} verticalAlign="middle">Ukupan broj izlazaka na svim ispitima</Table.HeaderCell>
                                <Table.HeaderCell colSpan={3} verticalAlign="middle">Broj studenata koji su položili predmet k</Table.HeaderCell>
                                <Table.HeaderCell colSpan={2} verticalAlign="middle">Prolaznost k/n</Table.HeaderCell>
                                <Table.HeaderCell colSpan={2} verticalAlign="middle">Prolaznost k/n₁</Table.HeaderCell>
                                <Table.HeaderCell colSpan={2} verticalAlign="middle">Prolaznost k/n₂</Table.HeaderCell>
                                {/*<Table.HeaderCell colSpan={1} verticalAlign="middle">Ocjene</Table.HeaderCell>*/}
                                <Table.HeaderCell colSpan={2}>Prosječna ocjena</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body> {currentPosts.map((el, index) =>
                            (<Table.Row
                                key={index}
                                style={HeaderCursor}
                                onClick={() => {
                                    this.setState({ student: el, showStudentInfo: true });
                                    localStorage.setItem('student', JSON.stringify(el));
                                }}
                            >
                                {/*<Table.Cell verticalAlign="middle" width={3}>*/}
                                {/*    {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.*/}
                                {/*</Table.Cell >*/}
                                <Table.Cell verticalAlign="middle" colSpan={4}>
                                    {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}. &nbsp; {el.courseBasicName}
                                    <span style={{ color: '#a6a4a1' }}><br/>{el.courseBasicComment ? el.courseBasicComment : ''}</span>
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={3}>
                                    {el.professor}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={3}>
                                    {el.numberOfStudentsOnCourse}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={3}>
                                    {el.numberOfDistinctStudentGradedActivities}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={3}>
                                    {el.numberOfExamRegistrations}
                                </Table.Cell>
                                 <Table.Cell verticalAlign="middle" colSpan={3}>
                                     {el.numberOfDistinctStudentsWhoAccessedExam}
                                 </Table.Cell>
                                 <Table.Cell verticalAlign="middle" colSpan={3}>
                                     {el.numberOfStudentsWhoAccessedExam}
                                 </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={3}>
                                    {el.numberOfStudentsWhoPassed}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={2}>
                                    {el.averagePassedStudentsOnCourse} %
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={2}>
                                     {el.averagePassedDistinctStudentGradedActivities} %
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={2}>
                                    {el.averagePassed} %
                                </Table.Cell>
                                {/*<Table.Cell verticalAlign="middle" textAlign="center" colSpan={1}>*/}
                                    {/*<Popup*/}

                                    {/*    content={*/}
                                    {/*        <PieChart*/}
                                    {/*            options={{*/}
                                    {/*                title: {*/}
                                    {/*                    text: el.courseBasicName*/}
                                    {/*                },*/}
                                    {/*                chart: {*/}
                                    {/*                    width: '100%',*/}
                                    {/*                    type: 'pie',*/}
                                    {/*                    toolbar: {*/}
                                    {/*                        show: true,*/}
                                    {/*                        offsetX: 0,*/}
                                    {/*                        offsetY: 0,*/}
                                    {/*                        tools: {*/}
                                    {/*                            download: true,*/}
                                    {/*                            selection: true,*/}
                                    {/*                            zoom: true,*/}
                                    {/*                            zoomin: true,*/}
                                    {/*                            zoomout: true,*/}
                                    {/*                            pan: true,*/}
                                    {/*                            customIcons: []*/}
                                    {/*                        },*/}
                                    {/*                        export: {*/}
                                    {/*                            csv: {*/}
                                    {/*                                filename: 'Statistics',*/}
                                    {/*                                columnDelimiter: ',',*/}
                                    {/*                                headerCategory: 'Ocjene',*/}
                                    {/*                                headerValue: 'Studenti',*/}
                                    {/*                                dateFormatter(timestamp) {*/}
                                    {/*                                    return new Date(timestamp).toDateString();*/}
                                    {/*                                }*/}
                                    {/*                            },*/}
                                    {/*                            svg: {*/}
                                    {/*                                filename: 'Statistics',*/}
                                    {/*                            },*/}
                                    {/*                            png: {*/}
                                    {/*                                filename: 'Statistics',*/}
                                    {/*                            }*/}
                                    {/*                        },*/}
                                    {/*                        autoSelected: 'zoom'*/}
                                    {/*                    },*/}
                                    {/*                },*/}
                                    {/*                colors,*/}
                                    {/*                fill: {*/}
                                    {/*                    colors*/}
                                    {/*                },*/}
                                    {/*                labels: ['pet', 'šest', 'sedam', 'osam', 'devet', 'deset', 'IO', 'NONP', 'Z', 'NZ', 'NO', 'UO'],*/}
                                    {/*                plotOptions: {*/}
                                    {/*                    pie: {*/}
                                    {/*                        dataLabels: {*/}
                                    {/*                            offset: -5,*/}
                                    {/*                        }*/}

                                    {/*                    }*/}
                                    {/*                },*/}
                                    {/*                responsive: [{*/}
                                    {/*                    breakpoint: 480,*/}
                                    {/*                    options: {*/}
                                    {/*                        chart: {*/}
                                    {/*                            width: 500*/}
                                    {/*                        },*/}
                                    {/*                        legend: {*/}
                                    {/*                            position: 'bottom'*/}
                                    {/*                        }*/}
                                    {/*                    }*/}
                                    {/*                }]*/}
                                    {/*            }}*/}
                                    {/*            series={[el.numberOfFs, el.numberOfEs, el.numberOfDs, el.numberOfCs,*/}
                                    {/*                el.numberOfBs, el.numberOfAs, el.numberOfIOs,*/}
                                    {/*                el.numberOfNONPs, el.numberOfZs, el.numberOfNZs,*/}
                                    {/*                el.numberOfNOs, el.numberOfUOs]}*/}
                                    {/*        />*/}
                                    {/*    }*/}
                                    {/*    on="click"*/}
                                    {/*    position="left center"*/}
                                    {/*    pinned*/}
                                    {/*    trigger={<Icon*/}
                                    {/*        color="blue"*/}
                                    {/*        name="pie chart"*/}
                                    {/*    />*/}
                                    {/*    }*/}
                                    {/*/>*/}
                                {/*</Table.Cell>*/}
                                <Table.Cell verticalAlign="middle" colSpan={2}>
                                    <Grid columns={1} centered stackable>
                                        <Grid.Column width="10">
                                            {el.averageGrade}
                                        </Grid.Column>
                                        <Grid.Column width="6" verticalAlign="middle" textAlign="right">
                                            <span>
                                                <Popup

                                                    content={
                                                        <PieChart
                                                            options={{
                                                                title: {
                                                                    text: el.courseBasicName
                                                                },
                                                                chart: {
                                                                    width: '100%',
                                                                    type: 'pie',
                                                                    toolbar: {
                                                                        show: true,
                                                                        offsetX: 0,
                                                                        offsetY: 0,
                                                                        tools: {
                                                                            download: true,
                                                                            selection: true,
                                                                            zoom: true,
                                                                            zoomin: true,
                                                                            zoomout: true,
                                                                            pan: true,
                                                                            customIcons: []
                                                                        },
                                                                        export: {
                                                                            csv: {
                                                                                filename: 'Statistics',
                                                                                columnDelimiter: ',',
                                                                                headerCategory: 'Ocjene',
                                                                                headerValue: 'Studenti',
                                                                                dateFormatter(timestamp) {
                                                                                    return new Date(timestamp).toDateString();
                                                                                }
                                                                            },
                                                                            svg: {
                                                                                filename: 'Statistics',
                                                                            },
                                                                            png: {
                                                                                filename: 'Statistics',
                                                                            }
                                                                        },
                                                                        autoSelected: 'zoom'
                                                                    },
                                                                },
                                                                colors,
                                                                fill: {
                                                                    colors
                                                                },
                                                                labels: ['pet', 'šest', 'sedam', 'osam', 'devet', 'deset', 'IO', 'NONP', 'NP', 'NA', 'Z', 'NZ', 'NO', 'UO'],
                                                                plotOptions: {
                                                                    pie: {
                                                                        dataLabels: {
                                                                            offset: -5,
                                                                        }

                                                                    }
                                                                },
                                                                responsive: [{
                                                                    breakpoint: 480,
                                                                    options: {
                                                                        chart: {
                                                                            width: 500
                                                                        },
                                                                        legend: {
                                                                            position: 'bottom'
                                                                        }
                                                                    }
                                                                }]
                                                            }}
                                                            series={[el.numberOfFs, el.numberOfEs, el.numberOfDs, el.numberOfCs,
                                                                el.numberOfBs, el.numberOfAs, el.numberOfIOs,
                                                                el.numberOfNONPs,  el.numberOfNPs,  el.numberOfNAs, el.numberOfZs, el.numberOfNZs,
                                                                el.numberOfNOs, el.numberOfUOs]}
                                                        />
                                                    }
                                                    on="click"
                                                    position="left center"
                                                    pinned
                                                    trigger={<Icon
                                                        size="small"
                                                        color="blue"
                                                        name="pie chart"
                                                    />
                                                    }
                                                />
                                            </span>
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                            </Table.Row>

                            ))}
                        </Table.Body>
                    </Table>}

                {currentPosts.length > 0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}
            </div>}
            </div>
        );
    }
}

export default CourseExamsStatistic;



// WEBPACK FOOTER //
// ./src/views/StudentService/Reports/ConstReports/CourseExamsStatistic.js